import * as React from 'react';

export interface AnalyticsLayoutProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;

  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */

  className?: string;

  /** Items that will be rendered  */
  items: React.ReactNode[];

  /** Shows or hides divider */
  showDivider?: boolean;

  /** @deprecated use showDivider instead
   * @default true
   */
  divider?: boolean;

  /** Sets minimum number of items per row
   * @default 2
   * */
  minItemsPerRow?: number;

  /** Sets maximum number of items per row
   * @default 3
   * */
  maxItemsPerRow?: number;

  /** Children  */
  children: AnalyticsLayoutChildren;
}

type AnalyticsLayoutChildren = (
  item: React.ReactNode,
  index: number,
  rowItemsCount: number,
) => React.ReactNode;

export interface AnalyticsLayoutCellProps {
  dataHook?: string;
  disableHighlight?: boolean;
  /** @default true */
  divider?: boolean;
  showDivider?: boolean;
  children: React.ReactNode;
}
